import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "ScreenReaderOnly__StyledSpan",
  componentId: "r18ed2-0"
})(() => ({
  position: 'absolute',
  top: 0,
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  border: 0
}));
export const ScreenReaderOnly = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledSpan, Object.assign({}, rest, {
    children: children
  }));
};